import dayjs from 'dayjs'
import React, { Component, Fragment } from 'react'
import LocalizationContext from '../../contexts/Localization/LocalizationContext'
import { ReactComponent as WarningIcon } from '../../assets/warning.svg'
import { Message, MessageType, Sender } from '../../globals'
import Markdown from '../Markdown'
import KnowledgeHitsComponent from './KnowledgeHitsComponent'
import MediaTypeComponent from './MediaTypeComponent'

type RenderMessagesProps = {
  talkToChat: (
    message: string,
    sender: Sender,
    type: MessageType,
    sendViaNetwork?: boolean
  ) => void
  chat: Message[]
  senderTypes: Sender[]
  withAvatars?: boolean
  userAvatar?: string
  agentAvatar?: string
  isWaitingForAgent?: boolean
  botName?: string
  channel?: string
  sessionId?: string | null
  baseHost?:string | null
  isInbox?:boolean;
}
export default class RenderMessages extends Component<RenderMessagesProps> {
  static contextType = LocalizationContext
  context!: React.ContextType<typeof LocalizationContext>



  render() {
    const { getLocalizedString } = this.context
    const {
      talkToChat,
      chat,
      senderTypes,
      withAvatars,
      userAvatar,
      agentAvatar,
      isWaitingForAgent,
      botName,
      channel,
      baseHost,
      isInbox
    } = this.props

    const lastResponseIndex = (() => {
      let lri = null
      if (isWaitingForAgent && chat.length) {
        let index = chat.length - 1
        while (index >= 0) {
          if (senderTypes.includes(chat[index].sender as Sender)) {
            index--
          } else if (
            chat[index - 1] &&
            chat[index - 1].sender === chat[index].sender
          ) {
            index--
          } else {
            lri = index
            break
          }
        }
      }
      return lri
    })()

    const lastIndex = chat?.length - 1;

    const renderedChat = chat.map(
      (
        {
          index,
          sender,
          timestamp,
          type,
          message,
          media_type,
          isFailed,
          ...otherProps
        },
        key
      ) => {
        const lastMessage = key === lastIndex;

        const getMessageClassNames = () => {
          const isCurrentUserSender = senderTypes
            .map((type) => type.toLowerCase())
            .includes(sender?.toLowerCase() || '')
          let classNames = isCurrentUserSender
            ? 'message user'
            : 'message customer'

          if (!key) {
            classNames = `${classNames} single`
          } else if (key + 1 >= chat.length) {
            classNames =
              chat[key - 1].sender !== sender
                ? `${classNames} single`
                : `${classNames} last`
          } else if (chat[key - 1].sender !== sender) {
            classNames =
              chat[key + 1].sender !== sender
                ? `${classNames} single`
                : `${classNames} first`
          } else if (chat[key + 1].sender !== sender) {
            classNames =
              chat[key - 1].sender !== sender
                ? `${classNames} single`
                : `${classNames} last`
          }

          return classNames
        }

        const getSenderText = () => {
          if (senderTypes[0] === sender) {
            return getLocalizedString('you', 'you')
          } else if(Sender.AGENT === sender) {
            return "Agent"
          }
          return botName || sender
        }

        if (!Object.values(MessageType).includes(type) && channel === 'TEST') {
          return (
            <div className={getMessageClassNames()} key={key}>
              <span className="message-meta">
                {`${getSenderText()} ${dayjs
                  .unix(timestamp || 0)
                  .format('HH:mm')}`}
              </span>
              <div className="message-text">
                <pre>
                  <code>
                    {JSON.stringify(
                      {
                        index,
                        timestamp,
                        ...otherProps,
                        type,
                        sender
                      },
                      null,
                      2
                    )}
                  </code>
                </pre>
              </div>
            </div>
          )
        }
        // @ts-ignore
        if(chat?.length && chat[0].sender === "SYSTEM" && chat[0]["replyType"] === "dataReply" && chat[0]["data"].INBOX_DISABLED === true ){
          return (
            <div className="message error" key={key}>
              <div className="message-text">
                <div>
                  <WarningIcon />
                  <p className="title"></p>
                </div>
                {/* @ts-ignore */}
                {chat[0]["data"].INBOX_DISABLED_MESSAGE}
              </div>
            </div>
          )


        }

        switch (type) {
          case MessageType.OPTIONS:
            return (
              <div className="message options" key={key}>
                {otherProps.options?.map((option, key) => (
                  <button
                    type="button"
                    onClick={() => {
                      talkToChat(option, senderTypes[0], MessageType.TEXT)
                    }}
                    key={key}
                  >
                    {option}
                  </button>
                ))}
              </div>
            )
          // @not-enabled-yet
          // case 'show_rating':
          //   return (
          //     <div
          //       className="rating"
          //       key={key}
          //       style={{ paddingBottom: '1em' }}
          //     >
          //       <StarRating sendMessage={sendMessage} />
          //     </div>
          //   )

          case MessageType.MEDIA:
            return (
              <div
                className={`message media ${getMessageClassNames()}`}
                key={key}
              >
                <MediaTypeComponent
                  mediaType={media_type}
                  mediaData={{
                    url: otherProps.url,
                    description: otherProps.description,
                    ...otherProps
                  }}
                />
              </div>
            )
          case MessageType.HITS:
            return (
              <div
                className={`message knowledgeHits  ${getMessageClassNames()}`}
                key={key}
              >
                <KnowledgeHitsComponent
                  topic={otherProps.topic}
                  hits={otherProps.hits}
                />
              </div>
            )
          case MessageType.CUSTOM_COMPONENT:
            return (
              <div className="message custom" key={key}>
                {message}
              </div>
            )
          case MessageType.ERROR:
            return (
              <div className="message error" key={key}>
                <div className="message-text">
                  <div>
                    <WarningIcon />
                    <p className="title">Error</p>
                  </div>
                  {otherProps.error}
                </div>
              </div>
            )
          case MessageType.TEXT:
          case MessageType.STRING:
            return (
              <div
                key={key}
                data-testid={`userMsg_${index}`}
                className={getMessageClassNames()}
              >
                {withAvatars && (
                  <div
                    className={`message-avatar${
                      isWaitingForAgent && lastResponseIndex === index
                        ? ' loading'
                        : ''
                    }`}
                  >
                    <img
                      src={
                        senderTypes.includes(sender as Sender)
                          ? userAvatar
                          : agentAvatar
                      }
                    />
                  </div>
                )}
                <span className="message-meta">
                  {`${getSenderText()} ${dayjs
                    .unix(timestamp || 0)
                    .format('HH:mm')}`}
                </span>

                <Markdown content={message} sessionId={this.props.sessionId} baseHost={baseHost} isInbox={isInbox} lastMessage={lastMessage}/>

                {isFailed && (
                  <div className="on-failure">
                    {getLocalizedString('sendError', 'Failed to send')}
                  </div>
                )}
              </div>
            )
          default:
            return null
        }
      }
    )

    return <Fragment>{renderedChat}</Fragment>
  }
}

// export default React.memo(RenderMessages, (prevProps, nextProps) => {
//   const prevChat = prevProps.chat
//   const nextChat = nextProps.chat

//   if (prevChat.length === 0 || nextChat.length === 0) return false

//   if (prevProps.isWaitingForAgent !== nextProps.isWaitingForAgent) {
//     return false
//   }

//   if (prevProps.botName !== nextProps.botName) return false

//   return prevChat.length === nextChat.length
// })
